import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceMarkTaskAsCompletedNotificationState = createStateReducer(
  initialState,
  {
    [events.markTaskAsCompletedFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "markTaskAsCompleted",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceMarkTaskAsCompletedNotificationState };
